export default "__VITE_ASSET__CYz1o_r5__"